import React, { useState, useRef, useEffect, useMemo, memo, useCallback } from 'react'

import { connect } from 'react-redux'
import { Badge, Button, Modal } from 'antd'
import GamePlayModals from './gamePlayModals'
import { setGameIntroSteps, selectValueBuddies, handleRestart, setRemainingTime, fetchGameState, setChooseValueModal, setStep, selectToken, setGameState } from '../../reduxStore/actions/action'

import CustomBox from "../../assets/customText-box.png"
import UserInitials from '../components/userInitials'
import vbNameTag from "../../assets/TAg.png"




export const ChooseCorrectValue = ({ chooseValueModal, setChooseValueModal, correctValueBuddies, fetchGameState, gameAssets, utilAssets }) => {

    return (
        <div>
            <Modal
                visible={chooseValueModal}
                onCancel={() => { setChooseValueModal(false) }}
                footer={null}
                maskClosable={false}
                closeIcon={false}
                className='token-model'
                width={1000}
                style={{ overflow: 'hidden !important' }}
                centered={true}
            >
                <div className="r-c-c" style={{ width: "100%", height: "100%", textAlign: "center" }}>
                    <div className="r-c-c letsPlayFrame" style={{}} ><img style={{ width: "100%" }} src={utilAssets?.modalBg} alt="lets play" /></div>
                    <div className='r-c-c-c' style={{}} >
                        <div className="choose-title" style={{}}>
                            Choose your {correctValueBuddies?.length} value buddies correctly to start the game!
                            <div className='r-c-c play-btn  m-t-20' style={{ width: "100%" }} >
                                <Button onClick={() => {
                                    setChooseValueModal(false); fetchGameState(() => {
                                    }, () => { })
                                }}>OK</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

const RollDice = React.memo(({ diceValue, showDiceBtn, handleRollDice, diceRandom, diceAssets }) => {



    const handleClick = () => {
        handleRollDice();

    }


    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', alignItems: 'center', position: 'relative', width: '100%', height: '100%' }}>

            {console.log('inside dice roll', diceValue)}

            {showDiceBtn ? <div className='r-c-c done-btn' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%', height: '0%', }} >
                <img src={diceAssets[0]}
                    onClick={handleClick}
                    style={{
                        width: '25vh', height: '25vh',
                        objectFit: 'contain',
                        cursor: 'pointer'
                    }}  >

                </img>
                <Button onClick={handleClick} >Roll Dice</Button>
            </div>
                :
                diceValue ?

                    <div style={{ position: 'absolute', height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'flex-end' }}>
                        <img src={`${diceAssets?.[diceValue]}?${diceRandom}`}
                            id="gif-animation"
                            style={{
                                width: '20vw', height: '20vw',
                                display: diceAssets?.[diceValue] ? 'block' : 'none',
                                objectFit: 'contain',
                            }}  >

                        </img>
                    </div>
                    : null
            }

        </div>
    )
})

function debounce(func, wait) {
    let timeout;
    const debounced = (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func(...args), wait);
    };
    debounced.cancel = () => {
        clearTimeout(timeout);
    };
    return debounced;
}



function LeftSidePanel({ tokenCard, valueBuddiesImg, correctValueBuddies, setGameIntroSteps,
    gameIntroSteps,
    selectValueBuddies, handleRollDice, diceValue, showDiceBtn, setShowDiceBtn,
    handleQuestion, optionValue, question, lastReachedPosition, handleRestart,
    setSelectedOption, selectedOption, karmaFlag, randomIndex, runTimer,
    setRemainingTime, fetchGameState, setOptionValue, addedKarmas, removedKarmas, setAddedKarmas,
    setRemovedKarmas, diceRandom, setChooseValueModal, chooseValueModal, isGameOver, setStep, selectToken,
    userDetails, gameState, setGameState, gameAssets, utilAssets, diceAssets, audioAssets, isCustomModalOpen, setCustomModalOpen, setSelectedBuddy
}) {


    const memoId = useMemo(() => true, [addedKarmas, removedKarmas, karmaFlag]);
    console.log('left side panel params', diceValue, selectedOption, karmaFlag, randomIndex, lastReachedPosition,)
    const [isOpenModal, setIsOpenModal] = useState(false);
    const title = ["Identify the correct value buddies", "Select Your Token", "Karma Badges", "The Decision Impact"]
    const modalTitle = ["Oops!", "Good Job!", "Excellent!", "Let's Play"]
    const modalSubText = ["Value buddies that you selected are not correct", "You have selected 2 correct values only 1 is left", "You have selected all your value buddies", "You have selected 1 correct value only 2 is left",]
    const modalBtnText = ["TRY AGAIN", "OK", "NEXT", "PLAY"]
    const [selectedItems, setSelectedItems] = useState([]);
    const maxAllowed = correctValueBuddies?.length;
    const [isPlayerWin, setIsPlayWin] = useState(false);

    const [isNextEnabled, setIsNextEnabled] = useState(false);
    const [isRolled, setIsRolled] = useState(false);

    console.log("gameIntroSteps", gameIntroSteps)

    setTimeout(() => {
        if (isGameOver) {
            setIsPlayWin(true);

            // setTimeout(() => {
            //     setStep(4);
            // }, 1500)
        }

    }, 1000)

    const [questionPart, setQuestionPart] = useState(false);
    const [optionPart, setOptionPart] = useState(false);
    const [magnusPart, setMagnusPart] = useState(false);

    // useEffect(() => {
    //     if (selectedOption !== null) {

    //         const resetTimeout = setTimeout(() => {
    //             setSelectedOption(null);
    //         }, 2000);

    //         return () => clearTimeout(resetTimeout);
    //     }
    // }, [selectedOption, setSelectedOption]);


    useEffect(() => {

        if (karmaFlag != null && !optionValue) {
            setIsRolled(true);
            setMagnusPart(true)
            setTimeout(() => {
                setMagnusPart(false);
                if (question) {
                    setQuestionPart(true);
                    setTimeout(() => {
                        setQuestionPart(false);
                    }, 2000)
                } else {
                    setIsRolled(false);
                }

            }, karmaFlag == 1 ? 2000 : 3000)
        }
    }, [karmaFlag, question, optionValue])

    useEffect(() => {

        if (question && karmaFlag == null) {
            setIsRolled(true);
            if (sessionStorage.getItem('gateReached') != 'true') {
                sessionStorage.setItem('gateReached', true);
                setQuestionPart(true);
                //const audio = document.getElementById("audio-tag");
                //if(!audio.paused){
                // const audioPlayer = new Audio(audioAssets?.gateOpenSound);
                // audioPlayer.play().catch(error => {
                //console.error('Error playing the audio:', error);
                // });
                //}
                setTimeout(() => {
                    setQuestionPart(false);
                }, 2000)
            }
        }
    }, [karmaFlag, question, optionValue])
    useEffect(() => {

        if (optionValue) {
            setIsRolled(true);
            setOptionPart(true);
            const sound1 = audioAssets?.[optionValue?.sound]
            const sound2 = optionValue?.isCorrect ?
                audioAssets?.gateOpenSound
                : audioAssets?.snakeSound;

            const audio = document.getElementById("audio-tag");
            // sessionStorage.setItem("isResultOpen", "false");
            if (!audio.paused) {

                const audioPlayer1 = new Audio(sound1);
                audioPlayer1.play().catch(error => {
                    console.error('finally', 'Error playing the audio:', error);
                })
                if (sound1) {

                    audioPlayer1.addEventListener('ended', () => {
                        console.log('second sound')
                        // const audioPlayer2 = new Audio(sound2);

                        // audioPlayer2.play().catch(error => {
                        //     console.error('Error playing the audio:', error);
                        // });
                    })
                } else {

                    // const audioPlayer2 = new Audio(sound2);
                    // audioPlayer2.play().catch(error => {
                    //     console.error('Error playing the audio:', error);
                    // });
                }

            }
            // setTimeout(() => {
            //     sessionStorage.setItem("isResultOpen", "true");
            // }, 0)


            setTimeout(() => {
                setOptionPart(false);
                setOptionValue()
                if (karmaFlag == null)
                    setIsRolled(false);
                else {
                    console.log("called magnus start")
                    setMagnusPart(true)
                    setTimeout(() => {
                        console.log("called magnus end")
                        setMagnusPart(false);
                        if (question) {
                            setQuestionPart(true);
                            setTimeout(() => {
                                setQuestionPart(false);
                            }, 3000)
                        } else {
                            setIsRolled(false);
                        }
                        //

                    }, 3500)
                }


            }, 3000)
        }





    }, [karmaFlag, question, optionValue]);

    const [allAreTrue, setAllAreTrue] = useState(false);
    const arraysEqual = (a, b) => {
        if (a.length !== b.length) return false;
        a.sort();
        b.sort();
        for (let i = 0; i < a.length; i++) {
            if (a[i] !== b[i]) return false;
        }
        return true;
    };

    // useEffect(() => {
    //     setIsNextEnabled(selectedItems.length === maxAllowed);
    // }, [selectedItems]);

    useEffect(() => {
        setIsNextEnabled(selectedItems.length === maxAllowed);
        const selectedIds = selectedItems.map(item => item.id);
        setAllAreTrue(arraysEqual(selectedIds, [...correctValueBuddies]));
    }, [selectedItems]);


    const handleNext = () => {
        if (gameIntroSteps === 0) {
            if (selectedItems.length === maxAllowed) {
                const params = {
                    isChoosenCorrect: allAreTrue
                }
                selectValueBuddies(params, () => {
                    setIsOpenModal(true);
                }, () => {
                    console.log('Error while selecting value buddies');
                });
            } else {
                setIsOpenModal(true);
            }
        }
        setCustomModalOpen(false)
    };
    const isCorrect = (id) => {
        return correctValueBuddies.some(item => item === id);
    };
    const countCorrectSelectedItems = () => {
        return selectedItems.filter(item => isCorrect(item.id)).length;
    };
    const countSelected = countCorrectSelectedItems();
    const totalValueBuddies = correctValueBuddies.length;

    let countIndex = 0;
    if (countSelected === 0) {
        countIndex = 0;
    } else if (countSelected < totalValueBuddies) {
        countIndex = 1;
    } else if (countSelected === totalValueBuddies) {
        countIndex = 2;
    } else if (gameIntroSteps == 4) {
        countIndex = 3;
    }


    const handleCheckboxChange = (item) => {
        const isChecked = selectedItems.some(selected => selected.id === item.id);

        if (isChecked) {
            setSelectedItems(selectedItems.filter(selected => selected.id !== item.id));
        } else {
            if (selectedItems.length < maxAllowed) {
                setSelectedItems([...selectedItems, item]);
            }
        }
    };





    const MagnusBadges = () => {


        const triggerAnimation = useCallback((startId, endId, animationClass, id, index) => {
            const startElement = document.getElementById(startId);
            const endElement = document.getElementById(endId);
            if (!startElement || !endElement || document.getElementById(`img-${id}`))
                return

            console.log("start id came", startId)
            const startRect = startElement.getBoundingClientRect();
            const endRect = endElement.getBoundingClientRect();
            console.log('karam badge id', id)
            const newImg = document.createElement('img');
            newImg.setAttribute('src', badges[id]); // Replace with your image path
            newImg.setAttribute('id', `img-${id}`);
            newImg.className = animationClass;
            newImg.style.width = '100%';
            newImg.style.height = '100%';
            newImg.style.objectFit = 'contain';
            newImg.style.position = 'absolute';
            newImg.style.left = `${0}px`;
            newImg.style.top = `${0}px`;
            newImg.style.zIndex = '101'

            newImg.style.setProperty('--end-x', `${endRect.left - startRect.left}px`);
            newImg.style.setProperty('--end-y', `${endRect.top - startRect.top}px`);

            startElement.appendChild(newImg);
            const sound = karmaFlag == 1 ? audioAssets?.wonPointSound : audioAssets?.lostPointSound;
            const audio = document.getElementById("audio-tag");
            if (!audio.paused) {
                const audioPlayer = new Audio(sound)
                audioPlayer.play().catch(error => {
                    console.error('Error playing the audio:', error);
                });
            }

            newImg.addEventListener('animationend', () => {


                setTimeout(() => {
                    newImg.remove();
                    setAddedKarmas([]);
                    setRemovedKarmas([])
                }, karmaFlag == 1 ? 1000 : 500)




            });

        }, []);

        const debouncedActionRef = useRef(null);

        // useEffect(()=>{


        //     if (addedKarmas.length > 0) {
        //         const debouncedAction = debounce(() => {
        //         addedKarmas.forEach((id, index) => {
        //             triggerAnimation('karma-badge-1', 'badge-' + (4 - id), 'animate-to', 4 - id, index);
        //         });
        //     }, 500);
        //     debouncedAction();
        //     const cleanup = () => {
        //         clearTimeout(debouncedAction);
        //         setAddedKarmas([]);
        //         setRemovedKarmas([]);
        //       };
        //       return cleanup;
        //     } else if (removedKarmas.length > 0) {
        //         const debouncedAction = debounce(() => {
        //         removedKarmas.forEach((id, index) => {
        //             console.log(removedKarmas, 'inside');
        //             triggerAnimation('badge-' + (4 - id), 'karma-badge-1', 'animate-back', 4 - id, index);
        //         });

        //         }, 900);
        //         debouncedAction();
        //         const cleanup = () => {
        //             clearTimeout(debouncedAction);
        //             setAddedKarmas([]);
        //             setRemovedKarmas([]);
        //           };
        //           return cleanup;
        //             }


        //     }, [addedKarmas,removedKarmas,karmaFlag])



        const createDebouncedAction = useCallback(() => {
            if (removedKarmas.length > 0) {
                return debounce(() => {
                    removedKarmas.forEach((id, index) => {
                        console.log(removedKarmas, 'inside');
                        triggerAnimation('badge-' + (4 - id), 'karma-badge-1', 'animate-back', 4 - id, index);
                    });
                }, 500);
            } else if (addedKarmas) {
                return debounce(() => {
                    addedKarmas.forEach((id, index) => {
                        triggerAnimation('karma-badge-1', 'badge-' + (4 - id), 'animate-to', 4 - id, index);
                    });
                }, 500);

            }
        }, [removedKarmas, addedKarmas]);



        useEffect(() => {
            // Assign the debounced function to the ref
            debouncedActionRef.current = createDebouncedAction();

            // Call the debounced function
            debouncedActionRef.current();

            // Cleanup function to clear the timeout
            return () => {
                if (debouncedActionRef.current) {
                    debouncedActionRef.current.cancel();
                }
            };
        }, [createDebouncedAction]);
        // useEffect(() => {
        //     if (addedKarmas.length > 0) {
        //         addedKarmas.forEach((id, index) => {
        //             triggerAnimation('karma-badge-1', 'badge-' + (4 - id), 'animate-to', 4 - id, index);
        //         });
        //     } else if (removedKarmas.length > 0) {
        //         removedKarmas.forEach((id, index) => {
        //             console.log(removedKarmas, 'inside');
        //             triggerAnimation('badge-' + (4 - id), 'karma-badge-1', 'animate-back', 4 - id, index);
        //         });
        //     }
        // }, [addedKarmas, removedKarmas, karmaFlag, triggerAnimation]);


        const badges = [gameAssets?.badge5, gameAssets?.badge4, gameAssets?.badge3, gameAssets?.badge2, gameAssets?.badge1];
        let giving = karmaFlag == 1 ? true : karmaFlag == 0 ? false : "";

        // const [positions, setPositions] = useState({});
        // const [direction,setDirection]=useState(true);
        // useEffect(() => {
        //     const badge1 = document.getElementById(direction?'badge-1':'img-reverse-1').getBoundingClientRect();
        //     const karmaBadge1 = document.getElementById('karma-badge-1').getBoundingClientRect();

        //     const from = direction?karmaBadge1:badge1
        //     const to =  direction?badge1:karmaBadge1

        //     setPositions({
        //         fromX: from.left,
        //         fromY: from.top,
        //         toX: to.left,
        //         toY: to.top
        //     });

        //     const img1 = document.getElementById('img-1');
        //     img1.style.setProperty('--from-x', `${from.left}px`);
        //     img1.style.setProperty('--from-y', `${from.top}px`);
        //     img1.style.setProperty('--to-x', `${to.left}px`);
        //     img1.style.setProperty('--to-y', `${to.top}px`);
        // }, [direction]);





        // const handleButtonClick = () => {
        //     if (isAnimatingTo) {
        //         triggerAnimation('badge-4', 'karma-badge-1', 'animate-to');
        //     } else {
        //         triggerAnimation('karma-badge-1', 'badge-4', 'animate-to');
        //     }
        //     setIsAnimatingTo(!isAnimatingTo);
        // };

        // useEffect(() => {

        //     if(giving){
        //         removedIndexes.forEach((id)=>{
        //             triggerAnimation('badge-'+id, 'karma-badge-1', 'animate-to')
        //         })
        //     }else{
        //         newlyAddedIndexes.forEach((id)=>{
        //             triggerAnimation('karma-badge-1', 'badge-'+id, 'animate-to');
        //         })
        //     }




        // }, []);

        return (
            <div className='r-c-c' style={{
                color: "#44301E", fontWeight: "bolder", width: "100%",
                position: "relative", textAlign: "center", height: '100%',


            }}>
                {giving === true ? <div style={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }} >
                    <div style={{ fontSize: "25px" }} >Well Done!</div>
                    <div style={{ fontSize: "16px" }}>Here is a karma badge!</div>
                    <div style={{ position: "relative", left: "0px", width: "90%" }}> <img className='full-img' src={gameAssets?.magnusGivingImg} /> </div>
                    <div style={{ position: 'absolute', width: '6vw', height: '6vw', borderRadius: '100%', right: 15, top: '36%' }} id='karma-badge-1'>
                    </div>
                    {/* <button onClick={handleButtonClick}>click</button> */}
                </div> : giving === false ?
                    <div style={{ height: '100%', width: '100%', position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                        <div className='fallen-text-1'  >Oops! You have fallen back.</div>
                        <div className='fallen-text-2' >I'm taking the karma badges back!</div>
                        <div style={{ position: "relative", width: "90%" }}> <img className='full-img' src={gameAssets?.magnusTakingImg} />
                            <div style={{ position: 'absolute', width: '60px', height: '60px', borderRadius: '100%', left: '3vw', top: '8%' }} id='karma-badge-1'>
                            </div>
                        </div>

                    </div>
                    : null
                }
            </div>
        );
    }

    const ValueBuddyQuestion = () => {
        const [selectedQa, setSelectedQa] = useState(null);

        return (
            <>
                {questionPart ? <> <ValueBuddyQuestionGate /> </> : optionPart ? <ValueBuddyAnswerGate /> :
                    magnusPart ?
                        <MagnusBadges /> :
                        <>
                            <div className='r-c-c-c' style={{ textAlign: "center", position: "relative", height: '90%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>


                                <div className="parent-options " style={{ position: 'relative', height: '80%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', top: '0' }}>
                                    <div style={{ width: "100%", height: '90%', position: 'absolute', top: '10%' }}>

                                        <img className='full-img' src={gameAssets?.questionBg} alt="Left Question Background" style={{ width: '100%', height: '100%' }} />
                                    </div>
                                    <div style={{ width: "100%", height: '20%', minHeight: '100px', position: 'relative' }}>


                                        <img className='full-img' src={valueBuddiesImg?.[randomIndex]?.withName} alt="Value Buddy"
                                            style={{ maxHeight: 'fit-content', maxWidth: '40%', position: 'absolute', bottom: '0%', left: '50%', transform: 'translate(-50%,0%)', minWidth: '100px', minHeight: '100px', objectFit: 'cover' }} />


                                    </div>
                                    <div className='r-c-c' style={{ position: "relative", width: "40%" }} >
                                        <img className="full-img cursor-pointer" src={vbNameTag} />
                                        <div className='r-c-c vb-name' style={{}}>{valueBuddiesImg?.[randomIndex]?.name}</div>
                                    </div>
                                    {console.log("radom index with name", randomIndex)}
                                    <div className="scroll-bar-universal" style={{ padding: 10, maxHeight: '72%' }}>
                                        <span className="question-text  " style={{}}>
                                            {question?.question}
                                        </span>
                                        <div className='left-panel-options' style={{}}>
                                            {question?.options?.map((option, index) => (
                                                <div
                                                    key={option.id}
                                                    className='option-text cursor-pointer'
                                                    onClick={() => setSelectedQa(option.id)}
                                                >
                                                    <div style={{
                                                        color: optionValue?.optionId === option.id && optionValue?.isCorrect ? 'green' : 'black',
                                                        backgroundColor: selectedQa === option.id ? "#FFDBAA" : "transparent",
                                                        transform: selectedQa === option.id ? "scale(1.03)" : "scale(1)",
                                                        transition: "background-color 0.3s, transform 0.3s ease, box-shadow 0.3s ease",
                                                        borderRadius: 10,
                                                        padding: "10px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        position: "relative",
                                                        height: "100%",
                                                        boxShadow: selectedQa === option.id ? "0 0 8px 2px #52FF00" : "none",
                                                    }}>
                                                        <img
                                                            className='full-img'
                                                            src={gameAssets?.optionBg}
                                                            alt="Background"
                                                            style={{
                                                                position: 'absolute',
                                                                top: 0,
                                                                left: 0,
                                                                height: '100%',
                                                                width: '100%',
                                                                borderRadius: 10
                                                            }}
                                                        />
                                                        <div
                                                            style={{
                                                                position: 'relative',
                                                                zIndex: 1,
                                                                width: "100%",
                                                                height: "100%",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center"
                                                            }}
                                                        >
                                                            <div style={{ whiteSpace: "normal", textAlign: "center", width: "100%" }}>
                                                                {option.option}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}


                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className='r-c-c done-btn ' style={{ height: '10%' }}>
                                <Button disabled={selectedQa == null} onClick={() => { handleQuestion(selectedQa); }} style={{ position: 'absolute', top: '0%' }}>Submit</Button>
                            </div>
                        </>
                }
            </>
        )
    }

    const ValueBuddyQuestionGate = () => {
        console.log("randomIndex", randomIndex)

        // useEffect(() => {
        //     setSelectedBuddy(randomIndex)
        //     setCustomModalOpen(true)
        //     setTimeout(() => {
        //         setCustomModalOpen(false)
        //     }, 2000)
        // }, [])
        return (
            <div style={{ position: "relative", width: "100%", top: "30%" }}>
                <div style={{ position: "absolute", top: "32%" }} ><img className='full-img' src={gameAssets?.goodGateImg} /></div>
                <div style={{ position: "absolute", width: "45%", left: "56%", top: "120px" }} ><img className='full-img' src={valueBuddiesImg?.[randomIndex]?.happy} /></div>
                {console.log("radom index happy", randomIndex)}
            </div>
        )
    }
    const ValueBuddyAnswerGate = () => {
        // const [gifImg, setGifImg] = useState();
        // console.log('component invoked ===>', sessionStorage.getItem("isResultOpen"), typeof sessionStorage.getItem("isResultOpen"));
        // useEffect(() => {
        //     if (sessionStorage.getItem("isResultOpen") != "true") {

        //         const gate = optionValue?.isCorrect ? gameAssets?.goodGateImg : gameAssets?.badGateImg;
        //         setGifImg(gate);

        //     } else {

        //         const gateGif = optionValue?.isCorrect ? gameAssets?.goodPathAnimation : gameAssets?.badPathAnimation;
        //         setGifImg(gateGif);
        //     }

        // }, [])


        return (
            <div style={{ width: "100%", height: "100dvh" }}>
                <div className='bad-gate-text' style={{ fontSize: '1.5vw' }}>{optionValue?.metaInfo}</div>
                <div className='bad-gate-text-bg' ><img className='full-img' src={gameAssets?.metaInfoBg} />
                </div>
                <div className='' style={{ position: "absolute", top: "32%" }} >

                    <img className='full-img' src={optionValue?.isCorrect ? gameAssets?.goodPathAnimation : gameAssets?.badPathAnimation} />

                </div>
                <div style={{ position: "absolute", width: "33%", left: "56%", top: "50%" }} ><img className='full-img' src={optionValue?.isCorrect ? valueBuddiesImg?.[randomIndex]?.thumbsUp : valueBuddiesImg?.[randomIndex]?.sad} /></div>
                {console.log("radom index thumbs up, sad", randomIndex)}
            </div>
        )
    }
    const SuccessFullMessage = () => {
        const [showMagnus, setMagnus] = useState(true);
        useEffect(() => {
            const audio = document.getElementById("audio-tag");
            if (!audio.paused) {
                const audioPlayer = new Audio(audioAssets?.gameFinish);
                audioPlayer.play().catch(error => {
                    console.error('Error playing the audio:', error);
                });
            }
            setTimeout(() => {
                setMagnus(false);
                setTimeout(() => {
                    setStep(4)
                }, 2000)

            }, 2000)

        }, [])

        return (
            <div className='r-c-c-c' style={{ width: "100%", height: "100dvh", textAlign: "center" }}>
                {showMagnus ? <>
                    {/* <div className='final-mag-text' style={{ position: "relative", width: "65%", top: "5%" }}>
                        <img className='full-img' src={CustomBox} />
                        <div style={{ position: "absolute", fontSize: "25px", fontWeight: "bold", top: "30%", color: "#FFFFFF", alignItems: "center", left: "20%" }}>Custom Message</div>
                    </div> */}
                    <div style={{ position: "relative", maxWidth: "80%" }}>
                        <img className='full-img' src={gameAssets?.magnusFinalImg} />
                    </div>
                </> : <>
                    <div className='congo-text-1'>Congratulations!
                    </div>
                    <div className='congo-text-2 p-20'>You have reached the end of your Journey.</div>
                </>}

            </div>
        )
    }

    const getModalSubText = (countSelected, correctValueBuddies) => {
        if (countSelected === 0) {
            return "Value buddies that you selected are not correct";
        } else if (countSelected == correctValueBuddies) {
            return "You have selected all your value buddies";
        } else {
            return `You have selected ${countSelected} correct value${countSelected > 1 ? 's' : ''} only ${correctValueBuddies - countSelected} ${correctValueBuddies - countSelected > 1 ? 'are' : 'is'} left`;
        }
    };

    const SelectToken = () => {
        const [selectedTokenId, setSelectedTokenId] = useState(null);
        const [storeToken, setStoreToken] = useState(null);
        const [showToken, setShowToken] = useState(false);
        console.log("seledrtede", selectedTokenId, isNextEnabled)
        useEffect(() => { if (selectedTokenId) { setIsNextEnabled(true) } }, [selectedTokenId])

        const handleTokenClick = (token) => {
            console.log("checkidd", token, token?.id)
            setSelectedTokenId(token?.id);
            setStoreToken(token)
            setShowToken(true);

        };
        return (
            <>



                <div className='left-panel-intros scroll-bar-universal cursor-pointer' style={{}} >
                    {tokenCard?.map((item, index) => (
                        <div key={item.id} className="m-b-20" onClick={() => handleTokenClick(item)} >
                            <img className='full-img' src={item?.card} />
                        </div>
                    ))}
                </div>

                {showToken && <Modal open={showToken} closeIcon={false} className='r-c-c-c token-model' footer={null} bodyStyle={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }} centered={true} style={{}} onCancel={() => setShowToken(false)}  >
                    <div className='r-c-c-c' style={{ width: "40%", position: "relative" }}>
                        <img className="full-img" src={storeToken?.image} />
                        <span style={{ color: storeToken?.color }}> {storeToken?.name}</span>
                        <div style={{ color: "#FFFFFF", position: "absolute", fontWeight: "bold", fontSize: "80px", bottom: "-45px" }}> <UserInitials fullName={userDetails?.name} /></div>
                    </div>

                    <div className='r-c-c done-btn-learning m-t-50'  ><Button className='r-c-c' onClick={() => {

                        const params = {
                            selectedToken: selectedTokenId
                        }
                        selectToken(params, () => { setGameIntroSteps(4); setIsOpenModal(true); setShowToken(false); },
                            () => { setIsOpenModal(false); setShowToken(false) })

                    }} >Done</Button></div>
                </Modal>}

            </>

        );
    };
    // console.log("coreecttt", selectedItems, countCorrectSelectedItems(), countIndex, countSelected)
    return (
        <div style={{ height: '100%', width: '100%', position: 'relative' }}>
            <div style={{ height: '100%', width: '100%' }}> <img className="full-img" src={gameAssets?.leftPanelBg} style={{ height: '100%', width: '100%' }} /></div>
            <div className='left-panel-title' style={{}}>{title[gameIntroSteps]}
                {gameIntroSteps == 0 ?
                    <div className='left-panel-subtitle'>Click on the top left checkbox to select the right Value Buddy </div>
                    : null}
            </div>
            {gameIntroSteps == 0 ?
                <div className='left-panel-value-buddies' style={{ height: '80%', width: '100%' }}>
                    <div className="value-buddies-container scroll-bar-universal" style={{}}>
                        {valueBuddiesImg.map((buddy, index) => (
                            <div key={buddy.id} className="buddy">
                                <label onClick={() => {
                                    if (!selectedItems.some(selected => selected.id === buddy.id)) {
                                        setCustomModalOpen(true);
                                    } else {
                                        setCustomModalOpen(false);
                                    }
                                    setSelectedBuddy(buddy);
                                }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={selectedItems.some(selected => selected.id === buddy.id)}
                                        onChange={() => { handleCheckboxChange(buddy) }}
                                    // style={{
                                    //     accentColor: selectedItems.some(selected => selected.id === buddy.id)
                                    //         ? (isCorrect(buddy.id) ? 'green' : 'red')
                                    //         : '', cursor: "pointer"
                                    // }}
                                    />
                                    <img className="full-img-vb cursor-pointer" style={{}} src={buddy.image} />
                                    <div className='r-c-c' style={{ position: "relative" }} >
                                        <img className="full-img cursor-pointer" src={vbNameTag} />
                                        <div className='r-c-c vb-name' style={{}}>{buddy?.name}</div>
                                    </div>
                                </label>
                            </div>
                        ))}
                    </div>
                </div>
                : null}
            {/* {gameIntroSteps == 2 ?
                <div className='left-panel-intros'> <img className="full-img" src={karmaBadgesMeter} style={{ width: '100%', height: '100%', objectFit: 'contain' }} /></div>
                : null}
            {gameIntroSteps == 3 ?
                <div className='left-panel-intros'> <img className="full-img" src={barometer} style={{ width: '100%', height: '100%', objectFit: 'contain' }} /></div>
                : null} */}
            {gameState?.selectedToken || gameIntroSteps == 4 ? <div style={{ position: "absolute", bottom: "8%", width: "100%", height: '100%', top: 0 }}>

                {isPlayerWin ?
                    <div><SuccessFullMessage /> </div> :
                    <>
                        {isRolled == true ? <ValueBuddyQuestion /> :
                            isRolled == false ?

                                <RollDice
                                    diceValue={diceValue}
                                    showDiceBtn={showDiceBtn}
                                    handleRollDice={handleRollDice}
                                    diceRandom={diceRandom}
                                    diceAssets={diceAssets}
                                /> : null
                        }
                    </>
                }
            </div> : gameIntroSteps !== 1 ?
                <div className='r-c-c done-btn-learning' style={{ position: "absolute", width: "100%", top: '90vh' }}>
                    <Button disabled={!isNextEnabled} onClick={handleNext}>
                        NEXT
                    </Button>
                </div> : null
            }

            {gameIntroSteps == 1 ? <SelectToken />

                : null}

            {isOpenModal &&
                <GamePlayModals
                    isOpenModal={isOpenModal}
                    setIsOpenModal={setIsOpenModal}
                    title={gameIntroSteps == 4 ? modalTitle[3] : modalTitle[countIndex]}
                    subText={gameIntroSteps == 4 ? null : getModalSubText(countSelected, correctValueBuddies?.length)}
                    btnText={gameIntroSteps == 4 ? modalBtnText[3] : modalBtnText[countIndex]}
                    triggerValue={gameIntroSteps}
                    setTriggerFunction={setGameIntroSteps}
                    isNextActive={countIndex == 2 && gameIntroSteps <= 1 ? true : false}
                    setShowDiceBtn={setShowDiceBtn}
                    runTimer={runTimer}
                    setRemainingTime={setRemainingTime}
                    gameIntroSteps={gameIntroSteps}
                    fetchGameState={fetchGameState}
                    countSelected={countSelected}
                    correctValueBuddies={correctValueBuddies}
                    utilAssets={utilAssets}

                />}
            {chooseValueModal &&
                <ChooseCorrectValue chooseValueModal={chooseValueModal} setChooseValueModal={setChooseValueModal} correctValueBuddies={correctValueBuddies} fetchGameState={fetchGameState} gameAssets={gameAssets} utilAssets={utilAssets} />
            }
        </div>
    )
}

const mapStateToProps = state => {
    const { tokenCard, valueBuddiesImg, correctValueBuddies, gameIntroSteps,
        showDiceBtn, valueBuddiesArray, chooseValueModal, userDetails,
        gameState, gameAssets, utilAssets, diceAssets, audioAssets } = state?.SeTu;
    return {
        tokenCard, valueBuddiesImg, correctValueBuddies, gameIntroSteps,
        showDiceBtn, valueBuddiesArray, chooseValueModal, userDetails, gameState,
        gameAssets, utilAssets, diceAssets, audioAssets
    }
}


const mapDispatchToProps = dispatch => ({
    setGameIntroSteps: (val) => dispatch(setGameIntroSteps(val)),
    setChooseValueModal: (val) => dispatch(setChooseValueModal(val)),
    selectValueBuddies: (params, successCallBack, callBack) => dispatch(selectValueBuddies(params, successCallBack, callBack)),
    handleRestart: () => dispatch(handleRestart()),
    setRemainingTime: (val) => dispatch(setRemainingTime(val)),
    fetchGameState: (successCallBack, callBack) => dispatch(fetchGameState(successCallBack, callBack)),
    setStep: (val) => dispatch(setStep(val)),
    selectToken: (params, successCallBack, callBack) => dispatch(selectToken(params, successCallBack, callBack)),
    setGameState: (val) => dispatch(setGameState(val)),

})

export default memo(connect(mapStateToProps, mapDispatchToProps)(LeftSidePanel))
